<template>
    <div class="page gc">
        <div class="container g9">
            <div class="inner">
                <h1>Sign in to simply.</h1>
                <h3>Enter your details below</h3>

                <form v-on:submit="onSubmit" action="#" method="post" id="form">
                    <div class="input" ref="email" type="email" v-bind:class="{ 'error': emailError }">
                        <label>
                            <span>E-mail address</span>
                            <input type="email" placeholder="E-mail" v-model="email" tabindex="1" />
                        </label>
                        <div v-if="emailError" class="error-message">
                            {{emailErrorMessage}}
                        </div>
                    </div>
                    <div class="input" type="password" v-bind:class="{ 'error': passwordError }">
                        <label>
                            <span>Password <router-link v-if="!$route.query.h" to="/forgot-password">Forgot password?</router-link></span>
                            <input type="password" placeholder="Password" v-model="password" tabindex="2" />
                        </label>
                        <div v-if="passwordError" class="error-message">
                            {{passwordErrorMessage}}
                        </div>
                    </div>

                    <button v-bind:class="{ 'loading': isLoading }">Sign in</button>                    

                </form>
                <div class="okta">
                    Are you using okta? Please <a href="Okta/SignIn">sign in here</a>.
                </div>
            </div>
            <div>
                <p>Sply Tech ApS - All Rights Reserved</p>
            </div>
        </div>
    </div>
</template>

<script>
    import API from "../../Api"
    
    export default {
        data: () => ({
            password: null,
            passwordError: false,
            email: null,
            emailError: false,
            isLoading: false,
            passwordErrorMessage: "",
            emailErrorMessage: ""
        }),
        mounted: function() {
          //todo redirect if already logged in (except shared user type)
        },
        methods: {
            onSubmit (e) {
                e.preventDefault();

                this.isLoading = true;

                this.passwordError = this.password == null || this.password == "";
                this.emailError = this.email == null || this.email == "";

                if(this.passwordError || this.emailError)
                {
                    this.isLoading = false;

                    if (this.passwordError) {
                        this.passwordErrorMessage = "Password cannot be empty";
                    }

                    if (this.emailError) {
                        this.emailErrorMessage = "E-mail must be valid";
                    }

                    return false;
                }


                API.post("member/login", {
                    password: this.password,
                    email: this.email,
                    hash: this.$route.query.h
                }).then((res) => {
                    this.isLoading = false;

                    // This is a dataview login
                    if(res.data.forecastId)
                    {
                        window.location = res.data.url;
                        return;
                    }

                    // Make reload of page after login
                    window.location = this.$route.query.ReturnUrl ? this.$route.query.ReturnUrl : "/projects/active";
                }).catch((res) => {
                    this.isLoading = false;
                    if (res.response.data !== undefined && res.response.data !== null) {

                        let data = res.response.data;

                        this.passwordError = data.message.toLocaleLowerCase().includes("password");
                        this.emailError = data.message.toLocaleLowerCase().includes("e-mail");

                        if (this.passwordError) {
                            this.passwordErrorMessage = data.message;
                        }

                        if (this.emailError) {
                            this.emailErrorMessage = data.message;
                        }
                        
                    }
                    
                    console.log(res)
                })
            }
        }
    }
</script>
